import { Navigate, useParams } from "react-router-dom";

import { PermissionsEnum } from "@/auth/interfaces";
import { ROUTER_PATHS, useCheckPermissions, useLoaders } from "@/shared";
import { useGetFlota } from "@/shared/actions/erp";
import { SaveFlota } from "../../shared/components";

export type UpdateFlotaPageProps = {};

const UpdateFlotaPage: React.FC<UpdateFlotaPageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_change_flota);
  const returnUrlFlotasPagFlotasPage =
    ROUTER_PATHS.mantenimientoOperaciones.flotaNav;
  const { id } = useParams();
  const { data, isLoading, isRefetching } = useGetFlota(id!);

  useLoaders(isLoading);

  if (isLoading || isRefetching) return null;
  if (!data?.data?.id_flota)
    return <Navigate to={returnUrlFlotasPagFlotasPage} replace={true} />;

  return <SaveFlota titlePage="Editar flota" editFlota={data.data} />;
};

export default UpdateFlotaPage;
